import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from '../Layout/Layout';

const HeaderWrapper = styled(Box)`
  width: 100%;
  align-self: flex-start;
  display: none;
  /* overflow: hidden; */

  @media only screen and (max-width: ${props => props.theme.mq.large}) {
    display: flex;
    /* position: absolute; */
    width: 100%;
    border-bottom: 1px solid ${props => props.theme.colors.xDarkgray};
    z-index: ${props => props.theme.zIndex.headerMobile};
  }
`;

function Header({ isLoggedIn = false, children = null }) {
  return (
    <Fragment>
      {isLoggedIn && (
        <HeaderWrapper width={1} as="header">
          {children}
        </HeaderWrapper>
      )}
      {!isLoggedIn && <div />}
    </Fragment>
  );
}

Header.propTypes = {
  isLoggedIn: PropTypes.bool,
  children: PropTypes.node
};

export default Header;
